import React from 'react';
import { Service } from '../types';

interface ServiceCardProps {
  service: Service;
  isActive: boolean;
  onClick: () => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full text-left p-6 rounded-xl transition-all duration-300 ${
        isActive
          ? 'bg-blue-50 border-l-4 border-blue-600'
          : 'hover:bg-gray-50'
      }`}
    >
      <div className="flex items-center">
        <service.icon className={`h-6 w-6 ${
          isActive ? 'text-blue-600' : 'text-gray-400'
        }`} />
        <span className={`ml-3 font-medium ${
          isActive ? 'text-blue-600' : 'text-gray-900'
        }`}>
          {service.title}
        </span>
      </div>
    </button>
  );
};

export default ServiceCard;